export default {
  envStr: 'prodHuadong2',
  appName: '方舟物联网平台',
  apiHost: '/fenydata-java-gateway',
  docUrl: 'http' + '://doc.huadong2.fenydata.com',
}